import { createContext, SetStateAction, useContext } from "react";
import { CompetitionPrizeTypes, CompetitionsResponse } from "./types";

export type ManagementSubscriptionContext = {
  isSubscriptionLoading: boolean;
  isInvoicesLoading: boolean;
  allPackages: Package[];
  isButtonDisabled: boolean;
  setIsButtonDisabled: React.Dispatch<SetStateAction<boolean>>;
  subscriptionPlan: SubscriptionPlanUser;
  setSubscriptionPlan: React.Dispatch<SetStateAction<SubscriptionPlanUser>>;
  invoicesList: Invoice[];
  setInvoicesList: React.Dispatch<SetStateAction<Invoice[]>>;
  shouldShowCancelSubscriptionStep: boolean;
  setShouldShowCancelSubscriptionStep: React.Dispatch<SetStateAction<boolean>>;
  subsWillBeCancelled: boolean;
  activePricePlan: SubscriptionPriceUser;

  totalEntries: string;
  basePrice: string;

  botbPassCompetitions: CompetitionsResponse;
  setBotbpassCompetitions: React.Dispatch<SetStateAction<CompetitionsResponse>>;

  cancelProcessActiveStep: number;
  onNext: () => void;
  onOnPrevious: () => void;

  onCancelSubscriptionModal: () => void;

  straplineTexts: CompetitionPrizeTypes;
  setStraplineTexts: React.Dispatch<SetStateAction<CompetitionPrizeTypes>>;

  onCancelSubscription: () => void;
  onRenewSubscription: () => void;

  isInvoiceProcessing: boolean;
  setIsInvoiceProcessing: React.Dispatch<SetStateAction<boolean>>;
};

export const Context = createContext<ManagementSubscriptionContext>({
  isSubscriptionLoading: true,
  isInvoicesLoading: true,
  allPackages: [],
  isButtonDisabled: false,
  setIsButtonDisabled: null,
  subscriptionPlan: {
    amount: 0,
    cancel_at_period_end: false,
    currency: "",
    current_period_end: 0,
    current_period_start: 0,
    description: "",
    features: [],
    id: "",
    interval: "",
    intervalCount: 0,
    metadata: [],
    name: "",
    prices: [],
    productId: "",
    status: "",
  },
  setSubscriptionPlan: null,
  invoicesList: [],
  setInvoicesList: null,
  shouldShowCancelSubscriptionStep: false,
  setShouldShowCancelSubscriptionStep: null,
  subsWillBeCancelled: false,
  activePricePlan: {
    active: false,
    billing_scheme: "",
    created: 0,
    currency: "",
    custom_unit_amount: 0,
    id: "",
    livemode: false,
    lookup_key: "",
    metadata: { base_price: "", discount_value_card: "", upsell_discount_value_switch: "" },
    nickname: "",
    object: "",
    product: undefined,
    recurring: { interval: "", interval_count: 0, meter: undefined, trial_period_days: undefined, usage_type: "" },
    tax_behavior: "",
    tiers_mode: "",
    transform_quantity: undefined,
    type: "",
    unit_amount: 0,
    unit_amount_decimal: "",
  },
  totalEntries: "",
  basePrice: "",
  botbPassCompetitions: {
    played: [],
    lost: [],
  },
  setBotbpassCompetitions: null,
  cancelProcessActiveStep: 1,
  onNext: null,
  onOnPrevious: null,
  onCancelSubscriptionModal: null,
  straplineTexts: {
    PrizeStraplineText1: "",
    PrizeStraplineText2: "",
    PrizeStraplineText3: "",
  },
  setStraplineTexts: null,
  onRenewSubscription: null,
  onCancelSubscription: null,
  isInvoiceProcessing: false,
  setIsInvoiceProcessing: null,
});

export const useManagementSubscriptionContext = () => useContext(Context);
